import { render, staticRenderFns } from "./contract-list.vue?vue&type=template&id=568fe64c&scoped=true"
import script from "./contract-list.vue?vue&type=script&lang=js"
export * from "./contract-list.vue?vue&type=script&lang=js"
import style0 from "./contract-list.vue?vue&type=style&index=0&id=568fe64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568fe64c",
  null
  
)

export default component.exports